document.addEventListener('DOMContentLoaded', () => {
	const navigation = document.querySelector('#navigation');
	const toggle = navigation.querySelector('#navigation-toggle');
	const menuItems = navigation.querySelectorAll('.menu-item');

	toggle.addEventListener('click', () => {
		const isCollapsed = navigation.dataset.collapsed === 'true';
		navigation.dataset.collapsed = isCollapsed ? 'false' : 'true';
	});

	menuItems.forEach((menuItem) => {
		menuItem.addEventListener('click', () => {
			navigation.dataset.collapsed = 'true';
		});
	});

	window.addEventListener('scroll', () => {
		if (window.scrollY >= 200) {
			navigation.classList.add('navigation--full');
		} else {
			navigation.classList.remove('navigation--full');
		}
	});
});
